import { baseURL } from "../../util/Constant";
import { getMessage } from "../redux/messageSlice";
import { getAllHpFile, loading } from "../redux/hpSlice";

//Get All Print FIle
export const getAllHpFileFetch = () => (dispatch) => {
  dispatch(loading(false));
  fetch(`${baseURL}/hp/getAllHp`, { method: "GET" })
    .then((res) => res.json())
    .then((data) => {
      if (data.errorCode) {
        dispatch(getMessage(data.message));
        return;
      }
      //console.log(data);
      dispatch(getAllHpFile(data));
    })
    .catch((error) => {
      console.log(error);
    });
};

//Change print:false => true
  export const putUpdateHpFileFetch = (id, folderFabric, fileName) => (dispatch) => { 
    dispatch(loading(false));
    fetch(`${baseURL}/hp/updateHp`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id, folderFabric, fileName }),
    })
      .then((res) => res.json())
      .then((data) => {
        //  console.log(data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

